import { render, staticRenderFns } from "./PayFailTip.vue?vue&type=template&id=26152500&"
import script from "./PayFailTip.vue?vue&type=script&lang=js&"
export * from "./PayFailTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports